<template>
  <TheAdmin :title="uncle.username" :description="uncle.identity" :color="true">
    <div class="mt">
      <a-spin tip="로딩 중..." :spinning="isLoading">
        <a-card title="계정 정보">
          <a-form-item label="활성화:">
            <a-switch v-model="uncle.status" :loading="statusLoading" @click="switchStatus" />
          </a-form-item>
          <a-form-item
            label="이름:"
            :validate-status="details.username ? 'error' : ''"
            :help="details.username"
          >
            <a-input v-model="uncle.username" />
          </a-form-item>
          <a-form-item
            label="아이디:"
            :validate-status="details.identity ? 'error' : ''"
            :help="details.identity"
          >
            <a-input v-model="uncle.identity" />
          </a-form-item>
          <a-form-item
            label="잔액"
            :validate-status="details.amount ? 'error' : ''"
            :help="details.amount"
          >
            <a-input-number
              :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="value => value.replace(/\$\s?|(,*)/g, '')"
              v-model="uncle.amount"
              @change="onUpdateNumber"
              style="width: 90%"
            />
            <span style="margin-left: 5px;">원</span>
            <a-input placeholder="수정 사유" :disabled="!reasonField" v-model="uncle.reason" />
            <a-card>
              <a-form-item label="계산">
                <a-input-number
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  @change="onUpdateNumber"
                  v-model="amountDiff"
                  style="width: 90%; margin-right: 5px;"
                />원
              </a-form-item>
              <a-button-group>
                <a-button type="primary" icon="plus" @click="updateAmountDiff(true)">더하기</a-button>
                <a-button type="danger" icon="minus" @click="updateAmountDiff(false)">빼기</a-button>
              </a-button-group>
            </a-card>
          </a-form-item>
          <a-row :gutter="16">
            <a-col :md="12" :span="24">
              <a-form-item
                label="전화번호:"
                :validate-status="details.phone ? 'error' : ''"
                :help="details.phone"
              >
                <a-input @change="getMask('phone')" v-model="uncle.phone" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :span="24">
              <a-form-item
                label="이메일:"
                :validate-status="details.email ? 'error' : ''"
                :help="details.email"
              >
                <a-input v-model="uncle.email" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-col :span="24">
            <a-form-item
              label="비밀번호:"
              :validate-status="details.password ? 'error' : ''"
              :help="details.password"
            >
              <a-input-password autocomplete="new-password" v-model="uncle.password" />
            </a-form-item>
          </a-col>
        </a-card>
      </a-spin>
    </div>

    <a-row class="fl-right mt" :gutter="12">
      <a-col :span="8">
        <a-button :loading="isLoading" @click="onSignin" type="dashed" icon="login">로그인</a-button>
      </a-col>
      <a-col :span="8">
        <a-button :loading="isLoading" @click="onDelete" type="danger" icon="delete">삭제</a-button>
      </a-col>
      <a-col :span="8">
        <a-button :loading="isLoading" @click="onApply" type="primary" icon="save">저장</a-button>
      </a-col>
    </a-row>
  </TheAdmin>
</template>
<script>
import TheAdmin from "@/components/Admin/TheAdmin";
import config from "../../../config";
import Axios from "axios";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";
import router from "../../../router";
import AccountStatus from "../../../libs/AccountStatus";

export default {
  name: "AdminUncles",
  components: { TheAdmin },
  data() {
    return {
      reasonField: false,
      isLoading: false,
      statusLoading: false,
      details: {},
      amountDiff: 0,
      uncle: {
        idx: this.$route.params.idx,
        status: false,
        username: "로딩 중...",
        identity: "로딩 중...",
        email: "",
        phone: "",
        amount: 0,
        password: "",
        reason: ""
      }
    };
  },
  mounted() {
    this.refreshUncle();
  },
  methods: {
    onUpdateNumber() {
      this.reasonField = true;
    },
    updateAmountDiff(isPlus) {
      if (this.amountDiff === 0) return;
      this.reasonField = true;
      const amount = parseInt(this.uncle.amount);
      if (isPlus) {
        this.uncle.amount = amount + this.amountDiff;
      } else {
        this.uncle.amount = amount - this.amountDiff;
      }
      this.amountDiff = 0;
    },
    async switchStatus() {
      this.statusLoading = true;

      try {
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/admin/uncles/${this.uncle.idx}/status`,
          { withCredentials: true, params: { is: this.uncle.status } }
        );

        AxiosMiddleware(data.opcode);
      } catch {
        this.uncle.status = !this.uncle.status;
        config.alert.mixin({
          type: "error",
          title: "정보를 수정할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.statusLoading = false;
    },
    async onSignin() {
      const { idx, username } = this.uncle;

      this.$confirm({
        title: "사입삼촌 로그인",
        content: username + "님으로 로그인하시겠습니까?",
        okText: "네, 로그인합니다.",
        okType: "primary",
        cancelText: "아니요",
        async onOk() {
          try {
            const { data } = await Axios.patch(
              `${config.hostname}/v1/admin/uncles/${idx}`,
              null,
              {
                withCredentials: true
              }
            );

            if (AxiosMiddleware(data.opcode)) {
              switch (data.opcode) {
                case OPCODE.SUCCESS:
                  router.push("/uncle");
                  config.alert.mixin({
                    type: "success",
                    title: username + "님으로 로그인되었습니다."
                  });
                  break;
                default:
                  config.alert.mixin({
                    type: "error",
                    title: "알 수 없는 이유로 인해 로그인할 수 없습니다."
                  });
              }
            }
          } catch (err) {
            config.alert.mixin({
              type: "error",
              title: "로그인할 수 없습니다.\n인터넷 상태를 확인해주세요."
            });
          }
        }
      });
    },
    async onApply() {
      this.isLoading = true;
      this.details = { balance: {}, business: {} };
      try {
        const { data } = await Axios.post(
          `${config.hostname}/v1/admin/uncles/${this.uncle.idx}`,
          {
            username: this.uncle.username,
            identity: this.uncle.identity,
            email: this.uncle.email,
            phone: this.uncle.phone,
            amount: this.uncle.amount,
            password: this.uncle.password,
            reason: this.uncle.reason
          },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              router.push("/admin/uncles");
              config.alert.mixin({
                type: "success",
                title: "수정되었습니다."
              });
              break;
            case OPCODE.INVALID:
              this.details = Object.assign(
                { balance: {}, business: {} },
                data.details
              );

              config.alert.mixin({
                type: "warning",
                title: "오류를 확인해주세요."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "알 수 없는 이유로 정보를 수정할 수 없습니다."
              });
          }
        }
      } catch {
        config.alert.mixin({
          type: "error",
          title: "정보를 수정할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    async onDelete() {
      const { idx } = this.uncle;

      this.$confirm({
        title: "사입 삼촌 삭제",
        content:
          this.uncle.username +
          "님을 삭제하시겠습니까? 추후 복구할 수 없습니다.",
        okText: "네, 삭제합니다.",
        okType: "primary",
        cancelText: "아니요",
        async onOk() {
          try {
            const {
              data
            } = await Axios.delete(
              `${config.hostname}/v1/admin/uncles/${idx}`,
              { withCredentials: true }
            );

            if (AxiosMiddleware(data.opcode)) {
              switch (data.opcode) {
                case OPCODE.SUCCESS:
                  router.push("/admin/uncles");
                  config.alert.mixin({
                    type: "success",
                    title: "성공적으로 삭제되었습니다."
                  });
                  break;
                default:
                  config.alert.mixin({
                    type: "error",
                    title: "알 수 없는 이유로 인하여 삭제할 수 없습니다."
                  });
              }
            }
          } catch (err) {
            config.alert.mixin({
              type: "error",
              title: "삭제할 수 없습니다.\n인터넷 상태를 확인해주세요."
            });
          }
        }
      });
    },
    async refreshUncle() {
      try {
        this.isLoading = true;
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/admin/uncles/${this.uncle.idx}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.uncle = data.uncle;
              this.uncle.status = data.uncle.status === AccountStatus.enabled;
              break;
            default:
              router.push("/admin/uncles");
              config.alert.mixin({
                type: "error",
                title: "사입 삼촌이 존재하지 않습니다."
              });
              break;
          }
        }
        this.isLoading = false;
      } catch (err) {
        router.push("/admin/uncles");
        config.alert.mixin({
          type: "error",
          title:
            "사입 삼촌의 정보를 가져올 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    },
    getMask(type) {
      let num = this.uncle[type].replace(/[^0-9]/g, "");

      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      this.uncle[type] = res;
    }
  }
};
</script>
<style>
.mt {
  margin-top: 20px;
}
</style>